import { Component, Input, OnInit } from '@angular/core';
import { InceptionService, TranslationService } from '@proximus/ng-common';
import { CryptoService } from '../../services/crypto.service';
import { Product } from '@dch/products-business-logic';

declare let jQuery: any;
@Component({
  selector: 'mprd-jo-renewal-card',
  templateUrl: './jo-renewal-card.component.html',
})
export class JORenewalCardComponent implements OnInit {
  @Input() product: Product;
  @Input() outOfPackCardZoneTagging: string;
  private linkJointOffer: string;
  private encryptionKey: string;
  constructor(
    private translationService: TranslationService,
    private cryptoService: CryptoService,
    private inceptionService: InceptionService,
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.inceptionService.init();
    });
  }

  navigateToRenewJointOffer() {
    this.cryptoService
      .encryptMessage([this.product.accessNumber])
      .subscribe((data: any) => {
        const response = data.value;
        this.encryptionKey = response?.message;
        this.linkJointOffer =
          this.translationService.getTranslatedValueFor(
            'products.card.jointOffer.button.renew.link',
          ) + encodeURIComponent(this.encryptionKey);
        window.open(this.linkJointOffer, '_self');
      });
  }

  navigateToInformationJointOffer() {
    jQuery('#joRenewalConditions').foundation('reveal', 'open');
  }

  getTaggingZone() {
    return this.product?.packDescription
      ? this.product?.packDescription
      : this.outOfPackCardZoneTagging
        ? this.outOfPackCardZoneTagging
        : this.translationService.getTranslatedValueFor(
            'products.overview.otherProducts',
          );
  }
}
